<template>
  <div>
    <generic-modal
      :height="OrderDetailsModalDim.height"
      :width="OrderDetailsModalDim.width"
      :padding="OrderDetailsModalDim.padding"
      :modalClass="OrderDetailsModalDim.modalClass"
      overflowNotNeeded="true"
      contentScroll="1"
      v-if="isPreviousOrderPage"
    >
      <template v-slot:header>
        <div class="sticky-top">
          <div
            class="plr16 pt16 pb16 d-flex align-items-center"
            :class="[clientPlatform == 'Web' ? 'dt-mw-670' : 'border-bottom']"
          >
            <i class="hkfi-back fs-14 mr15 hand" @click="handleBackClick"></i>
            <div class="header-order-details">
              <span class="fs-14 bold lh24">Order Details</span>
              <span class="header-help" @click="handleHelpClick">Help</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div
          class="plr16"
          :class="[clientPlatform == 'Web' ? 'dt-mw-670' : '']"
        >
          <order-status
            :data-image-success="HongsDeliveryBagSuccess"
            :data-image-failure="HongsDeliveryBagFailure"
            :data-is-delivery="isOrderTypeDelivery"
            :data-order-type-title="OrderTypeTitle"
            :data-place="DeliveryAddressTitle"
            :data-location="DisplayDeliveryAddress || DisplayStoreAddress"
            :data-date-delivered="dateDelivered"
            :data-time-delivered="timeDelivered"
            :data-is-advance-order="isAdvanceOrder"
          ></order-status>
          <order-price-card class="pt16"></order-price-card>
        </div>

        <!-- @todo: not implementing in phase 1 -->
        <!-- <download-bill></download-bill> -->
      </template>
      <template v-slot:footer>
        <div class="footer-order-details-cta plrb16 pt3">
          <button class="send-otp-button secondary" @click="reorderCtaHandler">
            {{ ctaText }}
          </button>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import HongsDeliveryBagSuccess from "../../../default/images/global/hongsDeliveryBagSuccess.svg";
import HongsDeliveryBagFailure from "../../../default/images/global/hongsDeliveryBagFailure.svg";
import Pin from "../../../default/images/global/pin.svg";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_REORDER,
  EVENT_ORDER_DETAILS_PAGE_CLICK,
  EVENT_ORDER_DETAILS_PAGE_IMPRESSION,
} from "../helpers/analyticsEvents";
import { clientPlatform } from "../config/apiEndpoints";
import {
  OrderTypesTextForPastOrderFromCode,
  OrderTypesTextForFailedOrderFromCode,
  OrderTypesFromCode,
} from "../helpers/orderTypesConstants";
import { OrderTypesCode } from "../helpers/orderTypesConstants";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
export default {
  name: "PreviousOrderDetails",
  components: {
    GenericModal,
    OrderStatus: defineAsyncComponent(() => import("./OrderStatus.vue")),
    OrderPriceCard: defineAsyncComponent(() => import("./OrderPriceCard.vue")),
    DownloadBill: defineAsyncComponent(() => import("./DownloadBill.vue")),
  },
  props: {},
  data() {
    return {
      clientPlatform,
      OrderDetailsModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "full-screen-popup advance-order-modal",
      },
      HongsDeliveryBagSuccess,
      HongsDeliveryBagFailure,
      Pin,
    };
  },
  mounted() {
    this.$store.dispatch(
      keyMapsAction.GET_ORDER_DETAILS_DATA,
      LocalStorageFunc.getOrderId()
    );
    if (
      LocalStorageFunc.getOrderHistoryPage() ==
      OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
    ) {
      setTimeout(
        () =>
          EVENT_ORDER_DETAILS_PAGE_IMPRESSION({
            category: "Screen View",
            orderType: OrderTypesFromCode[this.deliveryTypeCode],
            orderStatus:
              this.$store.state.OrderTracking.trackOrder?.orderSummary
                ?.orderStatus ||
              LocalStorageFunc.getOrderSummary()?.orderStatus,
          }),
        2000
      );
    }
  },
  methods: {
    handleBackClick(e) {
      LocalStorageFunc.setOrderHistoryPage(OrderHistoryPages.MY_ORDERS);
      Utility.redirectToOrderHistoryOrRedirectUrl();
    },
    reorderCtaHandler(event) {
      event.cancelBubble = true;
      event.preventDefault();
      EVENT_CLICK_REORDER({
        category: "Re-order Clicked",
      });
      let items = LocalStorageFunc.getOrderSummary()?.items;
      this.addToCartOnReorder(items);
      Utility.sendToCartScreen();
    },
    addToCartOnReorder(items = []) {
      let reorderedItems = LocalStorageFunc.getReorderedItems();
      reorderedItems = [...reorderedItems, ...items];
      LocalStorageFunc.setReorderItemsOrder(reorderedItems);
    },
    handleHelpClick(e) {
      Utility.sendToHelpPage();
      EVENT_ORDER_DETAILS_PAGE_CLICK({
        category: "Help Clicked",
        orderType: OrderTypesFromCode[this.deliveryTypeCode],
        orderStatus:
          this.$store.state.OrderTracking.trackOrder?.orderSummary
            ?.orderStatus || LocalStorageFunc.getOrderSummary()?.orderStatus,
      });
    },
  },
  computed: {
    ctaText() {
      return this.isOrderFailed ? "Retry" : "Reorder";
    },
    isPreviousOrderPage() {
      return (
        LocalStorageFunc.getOrderHistoryPage() ==
        OrderHistoryPages.PREVIOUS_ORDERS_DETAIL
      );
    },
    OrderTypeTitle() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;

      return this.isOrderFailed
        ? OrderTypesTextForFailedOrderFromCode[deliveryTypeCode]
        : OrderTypesTextForPastOrderFromCode[deliveryTypeCode];
    },
    DeliveryAddressTitle() {
      return this.$store.state.OrderTracking.trackOrder?.orderSummary
        ?.deliveryAddress?.customer_address_name;
    },
    DisplayDeliveryAddress() {
      if (
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode === "D" ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType
          ?.deliveryTypeCode === "D"
      ) {
        return (
          this.$store.state.OrderTracking.trackOrder.orderSummary
            ?.deliveryAddress?.formatted_address ||
          LocalStorageFunc.getOrderSummary()?.deliveryAddress?.formatted_address
        );
      } else return "";
    },
    DisplayStoreAddress() {
      return (
        this.$store.state.OrderTracking.trackOrder.orderSummary?.store
          ?.addressLine ||
        LocalStorageFunc.getOrderSummary()?.store?.addressLine
      );
    },
    isOrderTypeDelivery() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;

      return deliveryTypeCode === OrderTypesCode.DELIVERY_CODE;
    },
    dateDelivered() {
      return this.isAdvanceOrder
        ? Utility.getDateStringFromTimeStamp(
            this.orderSummary?.advanceOrderDeliveryTime
          )
        : Utility.getDateStringFromTimeStamp(
            this.orderSummary?.deliveryTimeStamp
          );
    },
    timeDelivered() {
      return this.isAdvanceOrder
        ? Utility.getTimeFromTimeStamp(
            this.orderSummary?.advanceOrderDeliveryTime
          )
        : Utility.getTimeFromTimeStamp(this.orderSummary?.deliveryTimeStamp);
    },
    orderSummary() {
      let orderSummary =
        this.$store.state.OrderTracking.trackOrder.orderSummary;
      if (!orderSummary?.items) {
        return LocalStorageFunc.getOrderSummary();
      }
      return orderSummary;
    },
    deliveryTypeCode() {
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        LocalStorageFunc.getOrderSummary()?.deliveryOrderType?.deliveryTypeCode;
      return deliveryTypeCode;
    },
    isOrderFailed() {
      let orderStatus =
        this.$store.state.OrderTracking.trackOrder?.orderSummary?.orderStatus;
      return orderStatus == "FAILED" || orderStatus == "CANCELLED";
    },
    isAdvanceOrder() {
      return this.$store.state.OrderTracking.trackOrder?.orderSummary
        ?.advanceOrder;
    },
  },
};
</script>
